import {ListItem, UnorderedList} from 'evergreen-ui';
import React, {memo} from 'react';
import {Referral, ServiceLocationType} from '..';

type Props = {
    referral: Referral;
    fieldName: 'serviceLocations'
        | 'serviceLocationsParaprofessional'
        | 'serviceLocationsMidLevel'
        | 'serviceLocationsHighLevel'
        | 'serviceLocationsGroupCare';
}

const labels: Record<ServiceLocationType, string> = {
    Home: 'Home',
    ClinicCenter: 'Clinic/Center',
    Community: 'Community',
    Telehealth: 'Telehealth',
    SchoolDayCare: 'School/Day care',
    TelehealthAssessmentOnly: 'Telehealth - Assessment Only, Treatment in Person',
}

export const ServiceLocationRenderer = memo(function ServiceLocationRenderer({fieldName, referral}: Props) {
    const serviceLocations= referral[fieldName] as ServiceLocationType[];

    if (serviceLocations.length === 0) {
        return 'None';
    }

    return (
        <UnorderedList size={500}>
            {serviceLocations
                .filter((v) => labels[v] !== undefined)
                .map((value, key) => (
                <ListItem key={key}>{labels[value]}</ListItem>
            ))}
        </UnorderedList>
    )
});
